import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface EntityViewerDialogProps {
  open: boolean;
  onClose: () => void;
  entity: Record<string, any> | string | null;
  title: string;
  fallbackMessage: string;
}

const EntityViewerDialog: React.FC<EntityViewerDialogProps> = ({
  open,
  onClose,
  entity,
  title,
  fallbackMessage,
}) => {
  const renderEntityWithoutBraces = (entity: Record<string, any>) => {
    const stringifiedData = JSON.stringify(entity, null, 2);
    const lines = stringifiedData.split('\n');

    if (lines[0].trim() === '{' && lines[lines.length - 1].trim() === '}') {
      return lines.slice(1, -1).join('\n');
    }

    return stringifiedData;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: 'primary.main',
          color: 'common.white',
          py: 1.5,
          borderRadius: '8px 8px 0 0',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
          }}
        >
          <InfoOutlinedIcon fontSize="small" />
          <Typography variant="h6">{title}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ maxHeight: 400 }}>
        {entity ? (
          typeof entity === 'string' ? (
            <Typography variant="body1">{entity}</Typography>
          ) : (
            <pre>{renderEntityWithoutBraces(entity)}</pre>
          )
        ) : (
          <Typography variant="body2" color="text.secondary">
            {fallbackMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EntityViewerDialog;
